import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --doug-image-height: calc(300rem / var(--default-rem-px-count));
    }

    .doug-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      align-items: end;
    }

    /* The block sets align-items on the grid, which would collapse the shared
       rule inside its grid area; stretch it so the border-bottom lands at the
       block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .header {
      padding-bottom: calc(var(--text-stack-header-gap) - var(--block-row-gap));
    }

    .description {
      padding-bottom: calc(16rem / var(--default-rem-px-count));
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: flex;
      overflow-x: scroll;
      flex-direction: row;
      gap: calc(20rem / var(--default-rem-px-count));
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    .arrow {
      display: none;
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
    }

    .image-description {
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: var(--fs-caption);
      line-height: var(--lh-caption);
      letter-spacing: var(--ls-caption);
    }

    .image {
      img {
        height: var(--doug-image-height);
      }
    }

    @media (min-width: 600px) {
      :host {
        --doug-image-height: calc(400rem / var(--default-rem-px-count));
      }

      .doug-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        align-items: start;
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 7;
        grid-row: 2;
        align-self: baseline;
      }

      .description {
        grid-column: 7 / 11;
        grid-row: 2;
        align-self: baseline;
      }

      .header,
      .description {
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .image-description,
      .text-section {
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
      }

      .images {
        grid-column: 3 / 13;
        grid-row: 3;
        gap: max(
          calc(20rem / var(--default-rem-px-count)),
          var(--between-column-padding)
        );
        overflow-x: auto;
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .arrow {
        display: inherit;
        margin: calc(
            var(--doug-image-height) / 2 -
              calc(20rem / var(--default-rem-px-count))
          )
          auto 0 auto;
        width: calc(40rem / var(--default-rem-px-count));
        height: calc(40rem / var(--default-rem-px-count));
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          height: calc(16rem / var(--default-rem-px-count));
          width: calc(16rem / var(--default-rem-px-count));
        }
      }

      .images:hover ~ .arrow {
        background-color: #efefef;
      }

      .arrow:hover {
        background-color: #efefef;
        cursor: pointer;
      }

      .left-arrow {
        grid-column: 2;
        grid-row: 3;
        transform: rotate(180deg);
      }

      .right-arrow {
        grid-column: 13;
        grid-row: 3;
      }

      .image {
        img {
          height: var(--doug-image-height);
        }
      }
    }
  `,
];
